// extracted by mini-css-extract-plugin
export var dividerContainer = "_5x-0";
export var line = "_5x-1";